module.exports = {"id":"170481","name":"Ezequiel Garay","rating":"83","photo":"./data/images/photos/3/170481.png","club":{"name":"Valence CF","logo":"./data/images/clubs/ValenceCF.png"},"positions":["DC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/EzequielGaray0.json
// module id = 1318
// module chunks = 0